import { uri } from '../../api-endpoint';
import { deleteTemplateFn } from '../common';

export const deleteKoumuten = (token: string) => (koumutenId: number) =>
  deleteTemplateFn(token, uri.koumutenById(koumutenId));
